import React from "react";
import { TABLE_HEAD_LOT } from "../../component/Methods";

/** Shared column widths so main rows and expanded lot rows line up (table-layout: fixed). */
export function PositionsColgroup() {
  return (
    <colgroup>
      <col style={{ width: 52 }} />
      <col style={{ width: "11%" }} />
      <col style={{ width: "9%" }} />
      <col style={{ width: "10%" }} />
      <col style={{ width: "13%" }} />
      <col style={{ width: "15%" }} />
      <col style={{ width: "10%" }} />
      <col style={{ width: 96 }} />
      <col style={{ width: 104 }} />
      <col style={{ width: 90 }} />
      <col style={{ width: 56 }} />
    </colgroup>
  );
}

export const NUMERIC_POSITION_HEAD_IDS = new Set([
  "shares",
  "averageCostPerShare",
  "price",
]);

export const lotColumnLabel = (id) => TABLE_HEAD_LOT.find((h) => h.id === id);

export const lotHeaderCellSx = (theme) => ({
  fontWeight: 600,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
  whiteSpace: "nowrap",
  fontSize: "0.75rem",
  py: 0.75,
});
